import { render, staticRenderFns } from "./UniSearch.vue?vue&type=template&id=491ed7c3&"
import script from "./UniSearch.vue?vue&type=script&lang=js&"
export * from "./UniSearch.vue?vue&type=script&lang=js&"
import style0 from "./UniSearch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UniSearch.vue"
export default component.exports